import React from 'react';

import Puzzle from './components/Puzzle';

/**
 * 
 * @param {AppArgs} param0 
 */
const App = ({resourceFetcher, progressTracker, api}) => {

    return (
        <Puzzle
            api={api}
            progressTracker={progressTracker}
            resourceFetcher={resourceFetcher}
        />
    );
}

export default App;
